















import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * A small (i) beside a title or a setting that explains it on hover or tap, so a page lists names and
 * keeps the explanations one step away. Meant to be the one way IRES Office explains its settings
 * (administration programme, info icon on every setting), so it takes plain, already translated text.
 */
@Component
export default class InfoIconComponent extends Vue {
  /** The explanation, translated. */
  @Prop({ required: true })
  text!: string;

  /** An optional heading above it, e.g. the setting's name. */
  @Prop({ default: "" })
  label!: string;
}
